/**
 * Quiz store actions
 */

import { Dispatch } from 'react';

import {
  ReducerActionType,
  CartTotalType,
  Order,
  LineItem,
  Errors,
} from 'utils/types';

export const SET_CART_TOTAL = 'SET_CART_TOTAL';
export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER';
export const SET_LINE_ITEMS = 'SET_LINE_ITEMS';
export const SET_PROMO_INPUT_VALUE = 'SET_PROMO_INPUT_VALUE';
export const SET_CURRENT_PROMO_CODE = 'SET_CURRENT_PROMO_CODE';
export const SET_SHOULD_SHOW_PROMO_INPUT = 'SET_SHOULD_SHOW_PROMO_INPUT';
export const SET_IS_PROMO_APPLIED = 'SET_IS_PROMO_APPLIED';
export const SET_IS_OPEN = 'SET_IS_OPEN';
export const SET_SHOW_TOS = 'SET_SHOW_TOS';
export const SET_PROMO_ERRORS = 'SET_PROMO_ERRORS';
export const SET_CART_ERRORS = 'SET_CART_ERRORS';

export const setCartTotal = (
  dispatch: Dispatch<ReducerActionType>,
  payload: CartTotalType,
) => dispatch({ type: SET_CART_TOTAL, payload });

export const setCurrentOrder = (
  dispatch: Dispatch<ReducerActionType>,
  payload: Order,
) => dispatch({ type: SET_CURRENT_ORDER, payload });

export const setLineItems = (
  dispatch: Dispatch<ReducerActionType>,
  payload: LineItem[],
) => dispatch({ type: SET_LINE_ITEMS, payload });

export const setPromoInputValue = (
  dispatch: Dispatch<ReducerActionType>,
  payload: string,
) => dispatch({ type: SET_PROMO_INPUT_VALUE, payload });

export const setCurrentPromoCode = (
  dispatch: Dispatch<ReducerActionType>,
  payload: string,
) => dispatch({ type: SET_CURRENT_PROMO_CODE, payload });

export const setShouldShowPromoInput = (
  dispatch: Dispatch<ReducerActionType>,
  payload: boolean,
) => dispatch({ type: SET_SHOULD_SHOW_PROMO_INPUT, payload });

export const setIsPromoApplied = (
  dispatch: Dispatch<ReducerActionType>,
  payload: boolean,
) => dispatch({ type: SET_IS_PROMO_APPLIED, payload });

export const setIsOpen = (
  dispatch: Dispatch<ReducerActionType>,
  payload: boolean,
) => dispatch({ type: SET_IS_OPEN, payload });

export const setShowTOS = (
  dispatch: Dispatch<ReducerActionType>,
  payload: boolean,
) => dispatch({ type: SET_SHOW_TOS, payload });

export const setPromoErrors = (
  dispatch: Dispatch<ReducerActionType>,
  payload: Errors,
) => dispatch({ type: SET_PROMO_ERRORS, payload });

export const setCartErrors = (
  dispatch: Dispatch<ReducerActionType>,
  payload: Errors,
) => dispatch({ type: SET_CART_ERRORS, payload });
